import React from 'react';

const TermsAndConditions = () => {
  return (
    <div className="text-[#EAECEF] space-y-8 max-w-4xl mx-auto">
      <section className="mb-12">
        <h1 className="text-3xl font-bold mb-4">Terms and Conditions - DreamSync LucidTTS</h1>
        <p className="text-[#B0B4BB] mb-2">Last Updated: Feb 13, 2025</p>
        <p className="text-[#B0B4BB] leading-relaxed">
          Welcome to DreamSync LucidTTS. Please read these terms carefully before using our service.
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="text-2xl font-semibold text-[#EAECEF]">1. Acceptance of Terms</h2>
        <p className="text-[#B0B4BB] leading-relaxed">
          By accessing or using DreamSync LucidTTS ("Service") provided by VOQAI LABS PRIVATE LIMITED ("Company", "We", "Us"), you agree to these Terms and Conditions.
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="text-2xl font-semibold text-[#EAECEF]">2. Service Description</h2>
        <p className="text-[#B0B4BB] leading-relaxed">DreamSync LucidTTS is an advanced text-to-speech platform offering:</p>
        <ul className="list-disc pl-6 space-y-2 text-[#B0B4BB]">
          <li>Natural Voice Generation</li>
          <li>AI-Powered Voice Cloning</li>
          <li>Multi-Language Voice Synthesis</li>
          <li>Commercial and Personal Usage Options</li>
        </ul>
      </section>

      <section className="space-y-4">
        <h2 className="text-2xl font-semibold text-[#EAECEF]">3. User Obligations</h2>
        <p className="text-[#B0B4BB] leading-relaxed">Users must:</p>
        <ul className="list-disc pl-6 space-y-2 text-[#B0B4BB]">
          <li>Provide accurate registration information</li>
          <li>Maintain account security</li>
          <li>Use the service legally and ethically</li>
          <li>Respect intellectual property rights</li>
        </ul>
      </section>

      <section className="space-y-4">
        <h2 className="text-2xl font-semibold text-[#EAECEF]">4. Content Guidelines</h2>
        <p className="text-[#B0B4BB] leading-relaxed">Users must not generate:</p>
        <ul className="list-disc pl-6 space-y-2 text-[#B0B4BB]">
          <li>Harmful or malicious content</li>
          <li>Copyrighted material without permission</li>
          <li>Misleading or fraudulent content</li>
          <li>Content that violates third-party rights</li>
        </ul>
      </section>

      <section className="space-y-4">
        <h2 className="text-2xl font-semibold text-[#EAECEF]">5. Intellectual Property</h2>
        <div className="space-y-4">
          <h3 className="text-xl font-medium text-[#EAECEF]">5.1 Ownership</h3>
          <ul className="list-disc pl-6 space-y-2 text-[#B0B4BB]">
            <li>Service and technology belong to the Company</li>
            <li>Generated content rights as per license terms</li>
            <li>User retains rights to input content</li>
          </ul>
        </div>
      </section>

      <section className="space-y-4">
        <h2 className="text-2xl font-semibold text-[#EAECEF]">6. Service Availability</h2>
        <p className="text-[#B0B4BB] leading-relaxed">
          We strive for 99.9% uptime but do not guarantee uninterrupted service.
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="text-2xl font-semibold text-[#EAECEF]">7. Pricing and Payments</h2>
        <div className="space-y-4">
          <h3 className="text-xl font-medium text-[#EAECEF]">7.1 Subscription Plans</h3>
          <ul className="list-disc pl-6 space-y-2 text-[#B0B4BB]">
            <li>Free tier with basic features</li>
            <li>Premium tiers with additional features</li>
            <li>Enterprise solutions available</li>
          </ul>
        </div>
      </section>

      <section className="space-y-4">
        <h2 className="text-2xl font-semibold text-[#EAECEF]">8. Usage Limitations</h2>
        <ul className="list-disc pl-6 space-y-2 text-[#B0B4BB]">
          <li>Free Tier: Limited voice generations per month</li>
          <li>Paid Tiers: Increased generation limits</li>
          <li>Commercial usage requires specific tier</li>
          <li>Bandwidth and computational resources are limited</li>
        </ul>
      </section>

      <section className="space-y-4">
        <h2 className="text-2xl font-semibold text-[#EAECEF]">9. Privacy and Data Handling</h2>
        <p className="text-[#B0B4BB] leading-relaxed">We collect and process user data in accordance with our Privacy Policy, including:</p>
        <ul className="list-disc pl-6 space-y-2 text-[#B0B4BB]">
          <li>User registration information</li>
          <li>Usage metrics</li>
          <li>Payment transaction data</li>
          <li>Voice generation logs</li>
        </ul>
        <p className="text-[#B0B4BB] leading-relaxed mt-2">Data is processed to improve service and ensure user experience.</p>
      </section>

      <section className="space-y-4">
        <h2 className="text-2xl font-semibold text-[#EAECEF]">10. Liability and Disclaimers</h2>
        <p className="text-[#B0B4BB] leading-relaxed">The Company is not liable for:</p>
        <ul className="list-disc pl-6 space-y-2 text-[#B0B4BB]">
          <li>Content generated by users</li>
          <li>Indirect or consequential damages</li>
          <li>Service interruptions</li>
          <li>Third-party misuse of generated content</li>
        </ul>
      </section>

      <section className="space-y-4">
        <h2 className="text-2xl font-semibold text-[#EAECEF]">11. Termination</h2>
        <p className="text-[#B0B4BB] leading-relaxed">We reserve the right to:</p>
        <ul className="list-disc pl-6 space-y-2 text-[#B0B4BB]">
          <li>Suspend or terminate accounts</li>
          <li>Modify or discontinue service</li>
          <li>Refuse service to any user</li>
        </ul>
      </section>

      <section className="space-y-4">
        <h2 className="text-2xl font-semibold text-[#EAECEF]">12. Governing Law</h2>
        <p className="text-[#B0B4BB] leading-relaxed">
          These Terms are governed by the laws of India, with exclusive jurisdiction in Delhi courts.
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="text-2xl font-semibold text-[#EAECEF]">13. Contact Information</h2>
        <p className="text-[#B0B4BB] leading-relaxed">For queries: ram@dreamsync.co.in</p>
        <p className="text-[#B0B4BB] leading-relaxed">
          Registered Address: 3-39, Katta Colony, Kadiyam Mandalam, Andhra Pradesh 533126
        </p>
      </section>

      <footer className="text-[#B0B4BB] italic mt-12 pt-4 border-t border-[#3A3D3E]">
        By using DreamSync LucidTTS, you acknowledge and agree to these Terms and Conditions.
        For questions, contact us at support@dreamsync.ai
      </footer>
    </div>
  );
};

export default TermsAndConditions;